module.exports = __webpack_public_path__ + "static/header-14b41ba64d595f9ff94299166ea34885.jpg";